// React
import React from "react";
import MediaQuery from "react-responsive";
import classNames from "classnames";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./FlexContainer.less";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Component
//-------------------------------------------------------------------------------------------------------------------------------
class FlexContainer extends React.Component {
    render() {
        const { breakPoint, flexScales, className } = this.props;
        return (React.createElement("div", { className: className },
            React.createElement(MediaQuery, { maxWidth: breakPoint },
                React.createElement("div", { className: classNames(styles.containerNormal) }, this.props.children)),
            React.createElement(MediaQuery, { minWidth: breakPoint + 1 },
                React.createElement("div", { className: classNames(styles.containerFlex, className) }, this.props.children))));
    }
}
FlexContainer.defaultProps = {
    breakPoint: 480,
    className: ""
};
export default FlexContainer;
// simple hash
// http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
// for creating "unique" keys... is this good enough?
// globaly unique or within parent element?
//http://stack.formidable.com/radium/
// media queries IN react :D
// Can do a proper columned object based on number of children
// can pass parameter where it should collapse to fewer columns
// maybe pass 2dim arrray with break point and number of columns for break?
// [ {768, 4}, {480, 2}, {320, 1}]
